import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestAccommodationsPageLayoutQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GuestAccommodationsPageLayoutQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: { __typename?: 'TravelSettings'; accommodationsPageLayout?: Types.AccommodationsPageLayout | null } | null;
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      brannanNavigation: Types.BrannanNavigation;
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType };
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
    } | null;
  } | null;
};

export const GuestAccommodationsPageLayoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestAccommodationsPageLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accommodationsPageLayout' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'EnumValue', value: 'live' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestAccommodationsPageLayoutQuery__
 *
 * To run a query within a React component, call `useGuestAccommodationsPageLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestAccommodationsPageLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestAccommodationsPageLayoutQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGuestAccommodationsPageLayoutQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GuestAccommodationsPageLayoutQuery, GuestAccommodationsPageLayoutQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GuestAccommodationsPageLayoutQuery, GuestAccommodationsPageLayoutQueryVariables>(GuestAccommodationsPageLayoutDocument, baseOptions);
}
export function useGuestAccommodationsPageLayoutLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestAccommodationsPageLayoutQuery, GuestAccommodationsPageLayoutQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GuestAccommodationsPageLayoutQuery, GuestAccommodationsPageLayoutQueryVariables>(GuestAccommodationsPageLayoutDocument, baseOptions);
}
export type GuestAccommodationsPageLayoutQueryHookResult = ReturnType<typeof useGuestAccommodationsPageLayoutQuery>;
export type GuestAccommodationsPageLayoutLazyQueryHookResult = ReturnType<typeof useGuestAccommodationsPageLayoutLazyQuery>;
export type GuestAccommodationsPageLayoutQueryResult = Apollo.QueryResult<GuestAccommodationsPageLayoutQuery, GuestAccommodationsPageLayoutQueryVariables>;
